// (function () {
//     'use strict';

//     angular.module("imApp").factory("orderHeadCapJobService", ['$ihttp', function ($ihttp) {
//         let service = {
//             getOrderHeadCapJob: function (parms) {
//                 return $ihttp.post({
//                     method: 2071,
//                     parameters: parms || {}
//                 });
//             },
//             deletePrevious: function (edit) {
//                 return $ihttp.post({
//                     method: 2076,
//                     parameters: edit
//                 });
//             },
//             addProduction: function (mergeObj) {
//                 return $ihttp.post({
//                     method: 2073,
//                     parameters: mergeObj
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
